module.exports = __webpack_public_path__ + "static/img/menageService11.efeb47a5.png";